import React from "react";
import './Review.css'
const Review =(props) =>{
    return(

        <section id="Browse bikes by">
            <h4 class="text-center mt-4 text1" >Reviews</h4>
            <div class=" Container">
                <div class="w-75 col1">
                    <p class="text-secondary text-center p-2 ">3000+ unbiased, verified reviews from bike owners. Know the pros and cons of 200+ bike models from real owners.</p>
                    <div class="input-group mb-3 w-50 wid">
                        <input type="text" class="form-control " placeholder="Search bike e.g. Bajaj Dominar 400" aria-label="Recipient's username" aria-describedby="button-addon2"/>
                        <button type="button" class="btn btn-danger" id="button-addon2">Button</button>
                    </div>
                    <div class="row p-2">
                        <div class="container">
                            <div class="row text-center">
                                <div class="col-md-4 mb-4 mb-md-0">
                                    <div class="card">
                                        <div class="card-body py-4 mt-2">
                                            <div class="d-flex justify-content-center mb-4">
                                                <img src="https://as2.ftcdn.net/v2/jpg/02/69/99/41/1000_F_269994145_LMk28tYXTHvKb9STkpUVca7rd7oQfjtq.jpg"
                                                class="rounded-circle shadow-1-strong" width="100" height="100"  alt="img" />
                                            </div>
                                            <h5 class="font-weight-bold">Mohit</h5>
                                            <h6 class="font-weight-bold my-3">Pure ev scooter review</h6>
                                            <ul class="list-unstyled d-flex justify-content-center">
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                                <li>
                                                <i class="fas fa-star-half-alt fa-sm text-info"></i>
                                                </li>
                                            </ul>
                                            <p class="mb-2">
                                                <i class="fas fa-quote-left pe-2"></i>Huge sound in cabinet,no proper fixture to hold the battery...
                                            </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 mb-4 mb-md-0">
                                        <div class="card">
                                            <div class="card-body py-4 mt-2">
                                            <div class="d-flex justify-content-center mb-4">
                                                <img src="https://easydrawingart.com/wp-content/uploads/2019/08/How-to-draw-a-cartoon-character-1.jpg"
                                                class="rounded-circle shadow-1-strong" width="100" height="100"  alt="img"/>
                                            </div>
                                            <h5 class="font-weight-bold">Maddy</h5>
                                            <h6 class="font-weight-bold my-3">TVS Apache RTR 160 4V</h6>
                                            <ul class="list-unstyled d-flex justify-content-center">
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                            </ul>
                                            <p class="mb-2">
                                                <i class="fas fa-quote-left pe-2"></i>Go with apache...They treat you like premium customers...And...
                                            </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 mb-0">
                                        <div class="card">
                                            <div class="card-body py-4 mt-2">
                                            <div class="d-flex justify-content-center mb-4">
                                                <img src="https://www.pngitem.com/pimgs/m/36-360982_brown-hair-cartoon-character-boy-cartoon-transparent-brown.png"
                                                class="rounded-circle shadow-1-strong" width="100" height="100" alt="img"/>
                                            </div>
                                            <h5 class="font-weight-bold">Alex</h5>
                                            <h6 class="font-weight-bold my-3">Hero Destini 125 CC</h6>
                                            <ul class="list-unstyled d-flex justify-content-center">
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                                <li>
                                                <i class="fas fa-star fa-sm text-info"></i>
                                                </li>
                                                <li>
                                                <i class="far fa-star fa-sm text-info"></i>
                                                </li>
                                            </ul>
                                            <p class="mb-2">
                                                <i class="fas fa-quote-left pe-2"></i>Vibrates at 30_50 speed.Design-wise is ok. Major biggest th..
                                            </p>
                                            </div>
                                        </div>
                                    </div>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Review;   